export default function serializeUser(user) {
  if (!user) return {};
  return {
    'Login Type': user.loginType,
    'ViajaMas Connected': user.isViajaMasConnected || false,
  };
}



// WEBPACK FOOTER //
// ./serializers/user.js